import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  FormControlLabel,
  Checkbox,
  Button,
  Box,
} from "@mui/material";
import GavelIcon from "@mui/icons-material/Gavel";

const ChatPolicyDialog = ({ open, onAccept, onCancel }) => {
  const [agreed, setAgreed] = useState(false);

  return (
    <Dialog open={open} disableEscapeKeyDown maxWidth="xs" fullWidth>
      <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <GavelIcon color="primary" />
        Reglas del chat
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ mb: 2 }}>
          Para proteger a la comunidad, no está permitido compartir información
          de contacto (teléfonos, emails, usuarios de redes sociales o de apps
          de mensajería) para coordinar trabajo fuera de la plataforma.
        </Typography>
        <Typography variant="body2" color="error" sx={{ mb: 2, fontWeight: 600 }}>
          Si lo hacés, tu cuenta entrará en estado de suspensión. Si volvés a
          hacerlo, tu cuenta puede ser eliminada definitivamente.
        </Typography>
        <FormControlLabel
          control={
            <Checkbox
              checked={agreed}
              onChange={(e) => setAgreed(e.target.checked)}
            />
          }
          label="Entiendo y acepto esta regla de la plataforma"
        />
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Box sx={{ display: "flex", gap: 1, width: "100%" }}>
          {onCancel && (
            <Button fullWidth onClick={onCancel} color="inherit">
              Volver
            </Button>
          )}
          <Button fullWidth variant="contained" disabled={!agreed} onClick={onAccept}>
            Empezar a chatear
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default ChatPolicyDialog;
